import React from 'react';

const CheckDisabled = ({
    title = 'Активировать',
    className = '',
    color = "#0a0a0a",
    size,
    variant,
    rotate = false,
    onClick
}) => {
    return (
        <i
            className={`${className} spp-svg ${
                variant ? 'spp-svg-color-' + variant : ''
            } ${size ? 'spp-svg-size-' + size : ''} ${
                rotate ? 'rotate' : ''
            }`}
            onClick={onClick}
            style={{ color }} // Добавляем color как inline-стиль для иконки
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 4.233 4.233"
                fill={color} // Применяем цвет ко всему SVG
            >
                <title>{title}</title>
                <g
                    data-name="Rectangle 6235"
                    transform="scale(.26458)"
                    fill="none"
                    stroke="none"
                >
                    <rect rx="2" height="16" width="16"/>
                    <path
                        d="M2 0C.9 0 0 .9 0 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zm0 1h12c.563 0 1 .437 1 1v12c0 .563-.437 1-1 1H2c-.563 0-1-.437-1-1V2c0-.563.437-1 1-1z"
                        fill={color} // Дублируем fill для path (на всякий случай)
                    />
                </g>
            </svg>
        </i>
    );
};

export default CheckDisabled;